import { exopenApi } from "src/common/redux/api/exopenApi.js";
import type { ApiKey, CreateApiKeyRequest } from "../apiKeyTypes";

const apiKeyApi = exopenApi.injectEndpoints({
	endpoints: (builder) => ({
		getApiKeys: builder.query<ApiKey[], { companyDomainId: string }>({
			query: ({ companyDomainId }) => `edm-admin/v1/${companyDomainId}/api-key`,
			providesTags: (_result, _error, { companyDomainId }) => [
				{ type: "ApiKey", id: `LIST-${companyDomainId}` },
			],
		}),

		createApiKey: builder.mutation<ApiKey, CreateApiKeyRequest>({
			query: ({ companyDomainId, ...body }) => ({
				url: `edm-admin/v1/${companyDomainId}/api-key`,
				method: "POST",
				body,
			}),
			invalidatesTags: (_result, _error, { companyDomainId }) => [
				{ type: "ApiKey", id: `LIST-${companyDomainId}` },
			],
		}),

		setApiKeyActive: builder.mutation<
			void,
			{ companyDomainId: string; apiKeyId: string; active: boolean }
		>({
			query: ({ companyDomainId, apiKeyId, active }) => ({
				url: `edm-admin/v1/${companyDomainId}/api-key/${encodeURIComponent(
					apiKeyId,
				)}/${active ? "activate" : "deactivate"}`,
				method: "PUT",
			}),
			async onQueryStarted(
				{ companyDomainId, apiKeyId, active },
				{ dispatch, queryFulfilled },
			) {
				const patch = dispatch(
					apiKeyApi.util.updateQueryData(
						"getApiKeys",
						{ companyDomainId },
						(draft) => {
							const key = draft.find((k) => k.apiKey === apiKeyId);
							if (key) {
								key.active = active;
							}
						},
					),
				);
				try {
					await queryFulfilled;
				} catch {
					patch.undo();
				}
			},
			invalidatesTags: (_result, _error, { companyDomainId }) => [
				{ type: "ApiKey", id: `LIST-${companyDomainId}` },
			],
		}),
	}),
	overrideExisting: false,
});

export const {
	useGetApiKeysQuery,
	useCreateApiKeyMutation,
	useSetApiKeyActiveMutation,
} = apiKeyApi;
